import type { RawCoordinates } from '../map-types';
import { calculateCoordinatesDistance } from './calculate-coordinates-distance';

export const findMaxMinPoint = (
  points: RawCoordinates[],
  targetPoint: RawCoordinates,
  type: 'max' | 'min'
) => {
  const { point } = points.reduce(
    (maxMinPoint, point) => {
      const { distance: maxMinDistance } = maxMinPoint;
      const distance = calculateCoordinatesDistance(point, targetPoint);

      const maxMinFound =
        type === 'max' ? distance > maxMinDistance : distance < maxMinDistance;

      if (maxMinFound) {
        return {
          point,
          distance
        };
      }

      return maxMinPoint;
    },
    {
      point: points[0],
      distance: calculateCoordinatesDistance(points[0], targetPoint)
    }
  );

  return point;
};
